<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th v-if="highlightTemplate" scope="col" class="border-0">Template</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in puzzles" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
            <slot
              name="actions"
              :puzzleId="row.id"
              :puzzleName="row.name"
              :hasChildren="row.settings?.enableGroupedGeneration"
            />
        </td>
        <td v-if="highlightTemplate">
          {{ row.template_name ?? '' }}
        </td>
        <td class="td-2">
          <puzzle-buttons :puzzle="row" :eventName="eventName" />
        </td>
      </tr>
      <tr v-if="puzzles.length === 0">
        <td :colspan="highlightTemplate ? 4 : 3" class="no-content">
          Ainda não tem nenhum jogo cadastrado.
        </td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      :title="modalTitle"
      :message="modalMessage"
    />
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import PuzzleButtons from './PuzzleButtons.vue';
import PuzzleDelete from '../mixins/PuzzleDelete';

export default {
  name: 'puzzle-list-table',
  mixins: [PuzzleDelete],
  components: {
    ConfirmationModal,
    PuzzleButtons,
  },
  props: {
    puzzles: {
      type: Array,
      default: () => [],
    },
    eventName: {
      type: String,
      default: null,
    },
    highlightTemplate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectPuzzle: null,
      modalTitle: '',
      modalMessage: '',
    };
  },
  destroyed() {
    Events.$off(this.eventName);
  },
  mounted() {
    Events.$on(this.eventName, puzzle => {
      this.selectPuzzle = puzzle.id;
      const label = puzzle.is_template ? 'template' : 'jogo';

      this.modalTitle = `Confirme exclusão do ${label}`;
      this.modalMessage = `Tem certeza que deseja excluir o ${label} "${puzzle.name}"?`;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
